export const makeClobeEventName = (name: string) => `[Clobe]: ${name}`;
export const CARD_BILLING_CATEGORY_ID = 135 as const; // 신용카드 대금 카테고리 ID

export const DEMO_TRIAL_TOOLTIP_MSG =
  '데모 체험중에는 사용할 수 없는 기능이에요. 가입하고 사용하실 수 있어요.';
